module.exports = {"360203001":"石狮埠街道","360203002":"新厂街道","360203003":"里村街道","360203004":"周路口街道","360203005":"昌江街道","360203006":"新村街道","360203007":"珠山街道","360203008":"太白园街道","360203009":"昌河街道","360203100":"竟成镇","360203400":"高新技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360203.json
// module id = 1369
// module chunks = 0